import type { AnnotationCommandData } from '@festina/life-general-types/life'
import { dateUtils, typeUtils } from '@festina-life/core'
import {
  FormikDatePicker,
  FormikForm,
  FormikMultiSelect,
} from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import type { CommandDataFormProps } from '../..'
import { useTime } from '../..'
import { useHook } from '../../lenteHooks'

const validateKey = typeUtils.createValidator<AnnotationCommandData>()

export const AnnotationForm = (
  props: CommandDataFormProps<AnnotationCommandData>,
) => {
  const translate = useTranslate()
  const { data: time } = useTime()
  const today = dateUtils.dateAsServerStr(time)

  const { businessType } = useHook('routing.general.useAnnotationParams')()

  const defaultValue: AnnotationCommandData = {
    _type: 'AnnotationCommandData',
    applyDate: today,
    accessGroupAnnotation: {
      _type: 'AccessGroupAnnotation',
      businessType,
    },
  }

  return (
    <FormikForm initialValues={defaultValue} {...props}>
      <FormikDatePicker
        label={translate('annotation.applyDate')}
        name={validateKey('applyDate')}
        isRequired
      />
      <FormikMultiSelect
        label={translate('annotation.accessGroupAnnotation.group')}
        name={validateKey('accessGroupAnnotation.groups')}
        options={[]}
        isValueCreator
        isRequired
        valueFromString={(x) => x}
      />
    </FormikForm>
  )
}
